import { StateCreator } from "zustand";
import { AddressSlice } from "./addressStrore";
import { ResultsSlice } from "./resultsStore";

type SearchState = {
  searchString: string;
};

type SearchActions = {
  setSearchString: (searchString: string) => void;
  reset: () => void;
};

export type SearchSlice = SearchState & SearchActions;

const initialState: SearchState = {
  searchString: "",
};

export const createSearchSlice: StateCreator<
  SearchSlice & ResultsSlice & AddressSlice,
  [],
  [],
  SearchSlice
> = (set) => ({
  // initial state
  ...initialState,
  // actions
  setSearchString: (searchString: string) => set({ searchString }),
  reset: () => set(initialState),
});
